// From https://github.com/Shopify/theme-scripts/blob/8ec75eabae8579982f111e166f8b88501d3d8f50/packages/theme-cart/request.js#L1
export const getDefaultRequestConfig = () => {
  return JSON.parse(
    JSON.stringify({
      credentials: 'same-origin',
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        'Content-Type': 'application/json;'
      }
    })
  );
};

export const fetchJSON = (url, config) => {
  return fetch(url, config).then(function(response) {
    if (!response.ok) {
      throw response;
    }
    return response.json();
  });
};

/**
 * @param {Array.<{ id: Number, quantity: Number, properties: Object }>} cartItemsArray
 */
export const addMultipleItemsToCart = cartItemsArray => {
  // adds items to cart in a single AJAX request
  const config = getDefaultRequestConfig();
  config.method = 'POST';
  config.body = JSON.stringify({ items: cartItemsArray });

  return fetchJSON('/cart/add.js', config);
};
